import React, { Component } from "react";
import logger from "../logging/logger";

export default class LoginPage extends Component {
  constructor(props){
    super(props);
    this.state = {
      username: "",
      pwd: "",
      alertMessage: "",
      step: "credentials",
      challengeToken: "",
      otpInput: "",
      expiresInSeconds: 0,
      resendCooldown: 0,
      isSubmitting: false,
    };
    this.resendTimer = null;
  }

  componentWillUnmount(){
    if(this.resendTimer) clearInterval(this.resendTimer);
  }

  startResendCountdown(){
    if(this.resendTimer) clearInterval(this.resendTimer);
    this.setState({ resendCooldown: 60 });
    this.resendTimer = setInterval(() => {
      this.setState(prev => {
        if(prev.resendCooldown <= 1){
          clearInterval(this.resendTimer);
          this.resendTimer = null;
          return { resendCooldown: 0 };
        }
        return { resendCooldown: prev.resendCooldown - 1 };
      });
    }, 1000);
  }

  finishLogin(jsonRes){
    window.localStorage.setItem('auth', JSON.stringify(jsonRes));
    window.location.hash = '#dashboard';
    this.setCookie("auth_token", jsonRes.authToken.token, 30);
    window.location.reload();
  }

  async login(){
    if(this.state.isSubmitting) return;
    if(!this.state.username || !this.state.pwd) return;
    this.setState({ isSubmitting: true });

    const headers = { 'Content-Type': 'application/json' };
    let data = {
      'login': this.state.username,
      'pwd'  : this.state.pwd
    }

    try {
      var response = await fetch(global.api_url + 'login', { method: 'POST', headers: headers, body: JSON.stringify(data) });
    } finally {
      this.setState({ isSubmitting: false });
    }
    let jsonRes = await response.json();
    if(response.ok){
      if(jsonRes.mfa && jsonRes.mfa.required){
        this.setState({
          step: 'otp',
          challengeToken: jsonRes.mfa.challengeToken,
          expiresInSeconds: jsonRes.mfa.expiresInSeconds,
          otpInput: '',
          alertMessage: '',
        });
        this.startResendCountdown();
      }else{
        this.finishLogin(jsonRes);
      }
    }else {
      this.setState({
        alertMessage:
        <div className="callout callout-warning">
          <h6>Fehler: { jsonRes.message }</h6>
        </div>
      });
    }
  }

  async verify(){
    if(this.state.isSubmitting) return;
    if(!this.state.challengeToken || !this.state.otpInput) return;
    this.setState({ isSubmitting: true });

    const headers = { 'Content-Type': 'application/json' };
    let data = {
      'challengeToken': this.state.challengeToken,
      'code'          : this.state.otpInput
    }

    try {
      var response = await fetch(global.api_url + 'mfa/verify', { method: 'POST', headers: headers, body: JSON.stringify(data) });
    } finally {
      this.setState({ isSubmitting: false });
    }
    let jsonRes = await response.json();
    if(response.ok){
      this.finishLogin(jsonRes);
    }else {
      let msg;
      if(jsonRes.code === 'MFA_CODE_INVALID'){
        const remaining = jsonRes.attemptsRemaining != null ? ` Noch ${jsonRes.attemptsRemaining} Versuch(e).` : '';
        msg = `Falscher Anmelde-Code.${remaining}`;
      }else if(jsonRes.code === 'MFA_CHALLENGE_LOCKED'){
        msg = 'Zu viele Fehlversuche. Bitte fordern Sie einen neuen Code an.';
      }else if(jsonRes.code === 'MFA_CHALLENGE_INVALID'){
        msg = 'Der Anmelde-Code ist abgelaufen oder ungültig. Bitte fordern Sie einen neuen Code an.';
      }else{
        msg = jsonRes.message || 'Anmelde-Code ungültig.';
      }
      this.setState({
        alertMessage:
        <div className="callout callout-warning">
          <h6>Fehler: { msg }</h6>
        </div>
      });
    }
  }

  async resend(){
    if(this.state.resendCooldown > 0) return;
    const headers = { 'Content-Type': 'application/json' };

    var response = await fetch(global.api_url + 'mfa/resend', {
      method: 'POST', headers: headers, body: JSON.stringify({ challengeToken: this.state.challengeToken })
    });
    let jsonRes = await response.json();
    if(response.ok){
      this.setState({
        challengeToken: jsonRes.mfa.challengeToken,
        expiresInSeconds: jsonRes.mfa.expiresInSeconds,
        otpInput: '',
        alertMessage: '',
      });
      this.startResendCountdown();
    }else{
      let msg;
      if(jsonRes.code === 'MFA_RESEND_COOLDOWN'){
        msg = 'Bitte warten Sie, bevor Sie einen neuen Code anfordern.';
      }else if(jsonRes.code === 'MFA_CHALLENGE_INVALID'){
        msg = 'Die Anforderung ist abgelaufen. Bitte melden Sie sich erneut an.';
      }else{
        msg = jsonRes.message || 'Neuer Code konnte nicht angefordert werden.';
      }
      this.setState({
        alertMessage:
        <div className="callout callout-warning">
          <h6>Fehler: { msg }</h6>
        </div>
      });
    }
  }

  setCookie(name, value, daysToLive) {
    // Encode value in order to escape semicolons, commas, and whitespace
    var cookie = name + "=" + encodeURIComponent(value);
    
    if(typeof daysToLive === "number") {
        /* Sets the max-age attribute so that the cookie expires
        after the specified number of days */
        cookie += "; max-age=" + (daysToLive*24*60*60);
        
        document.cookie = cookie;
    }
  }


  render (){
    return(
      <div className="login-box" style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '5rem' }}>
        <div className="login-logo">
          <img src="dist/img/DIVOKA_Logo.png" alt="DiVoKa Logo"/>
        </div>

        <div className="card">
          <div className="card-body login-card-body">
            {this.state.step === 'otp' ? (
              <form action="" method="post" onSubmit={(e) => { e.preventDefault(); this.verify(); }}>
                <p className="login-box-msg">
                  Ein 6-stelliger Anmelde-Code wurde an Ihre E-Mail-Adresse gesendet.
                  Der Code ist {this.state.expiresInSeconds / 60} Minuten gültig.
                </p>
                <div className="input-group mb-3">
                  <input type="text"
                    className="form-control"
                    placeholder="Anmelde-Code"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    maxLength={6}
                    autoFocus
                    value={this.state.otpInput}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          this.verify()
                        }
                      }
                    }
                    onChange={(e) => this.setState({otpInput: e.target.value})} />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-key"></span>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-auto">
                    <button type="submit" className="btn btn-primary" disabled={this.state.isSubmitting}>
                      {this.state.isSubmitting ? 'Bitte warten...' : 'Code bestätigen'}
                    </button>
                  </div>
                </div>
                <p className="mb-1 mt-3 text-center">
                  {this.state.resendCooldown > 0 ? (
                    <span style={{ color: '#999' }}>Neuen Code anfordern in {this.state.resendCooldown}s</span>
                  ) : (
                    <a href="#/" onClick={(e) => { e.preventDefault(); this.resend(); }}>Neuen Code anfordern</a>
                  )}
                </p>
                <p className="mb-1 mt-2 text-center">
                  <a href="#/" onClick={() => this.setState({ step: 'credentials', challengeToken: '', otpInput: '', alertMessage: '' })}>Zurück zur Anmeldung</a>
                </p>
                <div id="alert-message" className="mt-4">
                    { this.state.alertMessage }
                </div>
              </form>
            ) : (
              <form action="" method="post">
                <div className="input-group mb-3">
                  <input type="text"
                    className="form-control"
                    placeholder="Benutzername"
                    value={this.state.username}
                    autoFocus
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          this.login()
                        }
                      }
                    }
                    onChange={(e) => this.setState({username: e.target.value})} />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-user"></span>
                    </div>
                  </div>
                </div>
                <div className="input-group mb-3">
                  <input type="password"
                    className="form-control"
                    placeholder="Password"
                    value={this.state.pwd}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          this.login()
                        }
                      }}
                    onChange={(e) => this.setState({pwd: e.target.value}) }
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-lock"></span>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-auto">
                    <button type="button" className="btn btn-primary" disabled={this.state.isSubmitting} onClick={() => this.login()}>
                      {this.state.isSubmitting ? 'Bitte warten...' : 'Login'}
                    </button>
                  </div>
                </div>
                <p className="mb-1 mt-3 text-center">
                  <a href="#/forgot-password">Passwort vergessen?</a>
                </p>
                <div id="alert-message" className="mt-4">
                    { this.state.alertMessage }
                </div>
            </form>
            )}
          </div>
        </div>
      </div>
    );
  }
}